export const kaErrorText = (error, fallback) => {
  const detail = error?.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    const messages = detail.map(item => typeof item === 'string' ? item : item?.msg).filter(item => typeof item === 'string' && item);
    if (messages.length) return messages.join('；');
  }
  if (detail && typeof detail === 'object') {
    const message = detail.message || detail.msg;
    return typeof message === 'string' ? message : fallback;
  }
  return fallback;
};
